module.exports = __webpack_public_path__ + "static/media/converter.1f951642.jpg";